import { signalStore, withState, withComputed, withMethods, patchState } from '@ngrx/signals';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ContractStatus, User } from '../services/users/users.model';
import { UsersService } from '../services/users/users.service';

type UserState = {
    user: User | undefined ;
    contract: ContractStatus | undefined ;
    loading: boolean;
}

const initialState: UserState = {
    user: undefined,
    contract: undefined,
    loading: true
};

export const UserStore = signalStore(

    { providedIn: 'root' },

    withState(initialState),

    withMethods((state) => {
        const usersService = inject(UsersService);
    
        return {
            load: async () => {
                patchState(state, {loading: true});
                const user = await usersService.getUser(false) ;
                if (user) {
                    const contract = await firstValueFrom(usersService.getContractStatus()) ;
                    patchState(state, {user, contract, loading: false});
                } else {
                    patchState(state, {user: undefined, contract: undefined, loading: false});
                }
            },
            refreshUser: async () => {
                patchState(state, {loading: true});
                const user = await usersService.getUser(true) ;
                if (user) {
                    patchState(state, {user, loading: false});
                } else {
                    patchState(state, {user: undefined, contract: undefined, loading: false});
                }
            }
        }
    })
);